import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgChevron = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      d="m10.728 13.328 4.95 4.95-1.415 1.414-6.364-6.364 6.364-6.364 1.414 1.414z"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgChevron);
export default Memo;
